import * as React from 'react';
import { Str } from '../../localization/translationKeys';
import { css } from '@emotion/core';
import LocalDiv from '../../localization/LocalDiv';
import { COLORS } from '../../globalStyle/colors';
import Msg from '../../localization/Msg';
import Spacer from '../../layout/Spacer';
import { faWrench } from '@fortawesome/free-solid-svg-icons';
import { FLEX_ROW, FLEX_COLUMN } from '../../layout/flexBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const styles = {

  footnote: css`
    margin: 10px 15px 0;
  `,
  footnoteIcon: css`
    color: ${COLORS.DARK_GREY};
  `,
  footnoteMsg: css`
    color: ${COLORS.DARK_GREY};
  `,
};


type Props = {
  className?: string;
};


/**
 * CreateSurvey: a component that shows the footnote message
 *
 * PureComponent: true
 * Redux Connected: false
 */
const CreateSurveyFootnote: React.FC<Props> = props => (
  <LocalDiv css={[FLEX_ROW, styles.footnote]}>
    <FontAwesomeIcon
      icon={faWrench}
      css={[FLEX_COLUMN, styles.footnoteIcon]}
      size={'1x'}
    />
    <Spacer sizePx={10} css={FLEX_COLUMN} />
    <Msg str={Str.CreateSurveyFootnote} css={[FLEX_COLUMN, styles.footnoteMsg]} />
  </LocalDiv>
);

export default CreateSurveyFootnote;
